import React from "react";
import styled from "styled-components";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useState } from "react";
import { useRBAC } from "../context/rbac/RBACContext";
import { DashboardModules } from "../config/app.config";

const Layout = styled.div`
	height: 100%;
	width: 100%;
	font-family: "Roboto", sans-serif;
	display: flex;
	flex-direction: column;
`;

const Content = styled.div`
	position: relative;
	width: 100%;
	overflow-y: auto;
	height: 100%;
`;

const Div = styled.div`
	position: relative;
	display: flex;
	height: 100%;
	width: 100%;
	overflow-x: hidden;
`;

const MachineLayout = (props) => {
	const [showSidebar, toggle] = useState(true);
	const { allowedSidebarLinksPerModule } = useRBAC();
	const allowedSidebarLinks = allowedSidebarLinksPerModule[DashboardModules.KIOSK];

	return (
		<Layout>
			<Header machinePage showSidebar={showSidebar} toggle={toggle} />
			<Div>
				<Sidebar config={allowedSidebarLinks} showSidebar={showSidebar} toggle={toggle} />
				<Content>{props.children}</Content>
			</Div>
		</Layout>
	);
};

export default MachineLayout;
